/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects"

import {
  LOAD_RECORDS_META_DATA,
  LOAD_EMPLOYEE,
  LOAD_FOLLOWUP_AUDIT,
  UPDATE_AUDIT_RATING,
  UPDATE_AUDIT_STATUS,
  UPDATE_AUDIT_REMARKS,
  LOAD_FIRST_AUDIT,
  LOAD_AUDIT_REMARK,
  LOAD_FOLLOWUP_HISTORY,
  ADD_COMPANY_RATING,
  ADD_GREEN_FLAG,
  ADD_SALE_PYRAMID
} from "./constants"

import {
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  loadEmployee,
  loadEmployeeSuccess,
  loadEmployeeError,
  loadFollowupAudit,
  loadFollowupAuditSuccess,
  loadFollowupAuditError,
  loadfirstAudit,
  loadfirstAuditSuccess,
  loadfirstAuditError,
  updateAuditRatingSuccess,
  updateAuditStatusError,
  updateAuditStatusSuccess,
  updateAuditRatingError,
  updateAuditRemarksSuccess,
  updateAuditRemarksError,
  loadAuditRemark,
  loadAuditRemarkSuccess,
  loadAuditRemarkError,
  loadFollowupHistory,
  loadFollowupHistorySuccess,
  loadFollowupHistoryError,
  addCompanyRatingSuccess,
  addCompanyRatingError,
  addFlagSuccess,
  addFlagError,
  addSalePyramidSuccess,
  addSalePyramidError
} from "./actions"

import {
  loadRecordsMetaData,
  loadEmployeeList,
  loadFollowupAuditDetails,
  updateAuditRatingDetails,
  updateAuditStatusDetails,
  updateAuditRemarksDetails,
  loadFirstAuditDetails,
  loadAuditRemarkList,
  loadFollowupHistoryList,
  addCompanyRatingList,
  addGreenList,
  addSalePyramidDetails
} from "./remotes"

// import { selectSession } from "../session/selectors"
// import { roleIds } from "../../helpers/tools"

function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({ 
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
   
      let company = yield call(loadRecordsMetaData, "company", "post")
      let branch = yield call(loadRecordsMetaData, "branch", "post")
      const department = yield call(loadRecordsMetaData, "department", "post")
      const source = yield call(loadRecordsMetaData, "source", "post")
      let recordsMetaData = {
        companyOptions:
          (company &&
            company.data &&
            company.data.length > 0 &&
            company.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign({}, { label: c.name, value: c._id })
              )) ||
          (company &&
            company.length > 0 &&
            company.map((c) =>
              Object.assign({}, { label: c.name, value: c._id })
            )) ||
          [],
        branchOptions:
          (branch &&
            branch.data &&
            branch.data.length > 0 &&
            branch.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  { label: c.name, value: c._id, companyId: c.companyId }
                )
              )) ||
          (branch &&
            branch.length > 0 &&
            branch.map((c) =>
              Object.assign(
                {},
                { label: c.name, value: c._id, companyId: c.companyId }
              )
            )) ||
          [],
      
        departmentOptions:
          (department &&
            department.data &&
            department.data.length > 0 &&
            department.data.map((c) =>
              Object.assign({}, { label: c.name, value: c._id })
            )) ||
          (department &&
            department.length > 0 &&
            department.map((c) =>
              Object.assign({}, { label: c.name, value: c._id })
            )) ||
          [],
        sourceOptions:
          (source &&
            source.data &&
            source.data.length > 0 &&
            source.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign({}, { label: c.sourceName, value: c._id })
              )) ||
          [],
      }

      yield put(loadRecordsMetaDataSuccess(recordsMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}
// Employee filter Saga

function* loadEmployeeSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_EMPLOYEE),
    })

    const { explicitLoad } = load

    // const { id } = explicitLoad || {}
    yield put(loadEmployee(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadEmployeeList)

        if (result) {
          yield put(loadEmployeeSuccess(result.data))
        } else {
          yield put(loadEmployeeError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadEmployeeError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadFollowupAuditSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_FOLLOWUP_AUDIT),
    })

    const { explicitLoad } = load

    const { searchvalue } = explicitLoad || {}
    yield put(loadFollowupAudit(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadFollowupAuditDetails, searchvalue)

        if (result) {
          yield put(loadFollowupAuditSuccess(result.data))
        } else {
          yield put(loadFollowupAuditSuccess([]))
          yield put(loadFollowupAuditError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadFollowupAuditSuccess([]))
        yield put(
          loadFollowupAuditError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}
//first 
function* loadFirstAuditSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_FIRST_AUDIT),
    })

    const { explicitLoad } = load

    const { searchvalue } = explicitLoad || {}
    yield put(loadfirstAudit(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadFirstAuditDetails, searchvalue)

        if (result) {
          yield put(loadfirstAuditSuccess(result.data))
        } else {
          yield put(loadfirstAuditSuccess([]))
          yield put(loadfirstAuditError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadfirstAuditSuccess([]))
        yield put(
          loadfirstAuditError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}
//Followup Audit Status

function* updateAuditStatusSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { approve } = yield race({
      approve: take(UPDATE_AUDIT_STATUS),
    })
    const { auditStatus } = approve || {}
    if (approve) {
      try {
        yield call(updateAuditStatusDetails, auditStatus)
        // yield delay(1000)
        yield put(
          updateAuditStatusSuccess(auditStatus, "Record Deleted Successfully")
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          updateAuditStatusError(
            (error && error.response && error.response.message) ||
              "Delete Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}
//Followup Audit Rating

function* updateAuditRatingSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { approve } = yield race({
      approve: take(UPDATE_AUDIT_RATING),
    })
    const { auditRating } = approve || {}
    if (approve) {
      try {
        yield call(updateAuditRatingDetails, auditRating)
        // yield delay(1000)
        yield put(
          updateAuditRatingSuccess(auditRating, "Record Updated Successfully")
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          updateAuditRatingError(
            (error && error.response && error.response.message) ||
              "Delete Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}
//Followup Audit Remarks

function* updateAuditRemarksSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { approve } = yield race({
      approve: take(UPDATE_AUDIT_REMARKS),
    })
    const { auditRemarks } = approve || {}
    if (approve) {
      try {
        yield call(updateAuditRemarksDetails, auditRemarks)
        // yield delay(1000)
        yield put(
          updateAuditRemarksSuccess(auditRemarks, "Record Updated Successfully")
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          updateAuditRemarksError(
            (error && error.response && error.response.message) ||
              "Delete Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* loadAuditRemarkSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_AUDIT_REMARK),
    })

    const { explicitLoad } = load

    const { searchvalue } = explicitLoad || {}
    yield put(loadAuditRemark(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadAuditRemarkList, searchvalue)

        if (result) {
          yield put(loadAuditRemarkSuccess(result.data))
        } else {
          yield put(loadAuditRemarkError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadAuditRemarkError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}
//load followup history  loadFollowupHistorySaga
 
function* loadFollowupHistorySaga() {
  while (true) {
    
    const load = yield race({
      explicitLoad: take(LOAD_FOLLOWUP_HISTORY),
    })

    const { explicitLoad } = load

    const { searchvalue } = explicitLoad || {}
    yield put(loadFollowupHistory(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadFollowupHistoryList,searchvalue)

        if (result) {
          yield put(loadFollowupHistorySuccess(result.data))
        } else {
          yield put(loadFollowupHistoryError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadFollowupHistoryError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}
//addCompanyRatingSaga
function* addCompanyRatingSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { approve } = yield race({
      approve: take(ADD_COMPANY_RATING),
    })
    const {companyDetails} = approve || {}
    if (approve) {
      try {
        yield call(addCompanyRatingList,companyDetails)
        // yield delay(1000)
        yield put(
          addCompanyRatingSuccess(companyDetails, "Record Updated Successfully")
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          addCompanyRatingError(
            (error && error.response && error.response.message) ||
              "Delete Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}
//add green flag
function* addFlagSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { approve } = yield race({
      approve: take(ADD_GREEN_FLAG),
    })
    const {flagDetails} = approve || {}
    if (approve) {
      try {
        yield call(addGreenList,flagDetails)
        // yield delay(1000)
        yield put(
          addFlagSuccess(flagDetails, "Record Updated Successfully")
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          addFlagError(
            (error && error.response && error.response.message) ||
              "Delete Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* addSalePyramidSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { approve } = yield race({
      approve: take(ADD_SALE_PYRAMID),
    })
    const {saleDetails} = approve || {}
    if (approve) {
      try {
        yield call( addSalePyramidDetails,saleDetails)
        // yield delay(1000)
        yield put(
           addSalePyramidSuccess( "Record Updated Successfully")
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
           addSalePyramidError(
            (error && error.response && error.response.message) ||
              "Delete Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}
export default function* recordsSaga() {
  yield all([
    loadRecordsMetaDataSaga(),
    loadEmployeeSaga(),
    loadFollowupAuditSaga(),
    updateAuditStatusSaga(),
    updateAuditRatingSaga(),
    updateAuditRemarksSaga(),
    loadFirstAuditSaga(),
    loadAuditRemarkSaga(),
    loadFollowupHistorySaga(),
    addCompanyRatingSaga(),
    addFlagSaga(),
    addSalePyramidSaga()
  ])
}
